import {Component, Input, OnInit} from '@angular/core';
import {ILayoutSettings, IPageContent} from '@app/feature/store-editor/components/layout/store-editor.interface';
import {CommonService} from '@app/feature/store-editor/services/common.service';

@Component({
  selector: 'app-tesimonial',
  templateUrl: './tesimonial.component.html',
  styleUrls: ['./tesimonial.component.css']
})
export class TESIMONIALComponent implements OnInit {
  @Input() item: IPageContent;
  @Input() layoutSetting: ILayoutSettings;

  constructor(public cs: CommonService) {
  }

  ngOnInit() {
  }

  imageSelector(image: string) {
    if (image) {
      return image;
    } else {
      return '/assets/img/imagePlaceholder.png';
    }
  }

}
